    <div class="inputContainer">
        <app-reg-common-form [inputDataList]="inputDataList" showSubmit="true" submitBtnText="CREATE ACCOUNT"
            [heading]="heading" (formButtonResEvent)="formButtonResEvent($event)" formName="facilityRegister"></app-reg-common-form>
            <!-- showTermsCondition="true" -->
    </div>

    <!-- <div class="termsCondition">
        <input type="checkbox" id="termsCondition" name="termsCondition" value="termsCondition">
        <div style="margin-left:5px">By clicking create account, I agree to
            <span style="color:rgb(243, 54, 111); font-weight:600; cursor:pointer;">terms and conditions</span>
        </div>
    </div> -->

    <!-- <button (click)="createAccount()">CREATE ACCOUNT</button> -->